import React from "react";
import Footer from "../components/Footer";

const ContactUs = () => {
  return (
    <div className="min-h-screen bg-black text-white py-16 px-6 md:px-12 mt-12">
      {/* Text oben */}
      <div className="max-w-3xl mx-auto text-center space-y-6 mb-16">
        <h2 className="text-4xl font-bold">Kontakt</h2>
        <p className="text-lg text-white">
          Wir freuen uns auf Ihre Nachricht! Kontaktieren Sie uns gerne für
          Terminvereinbarungen, Fragen oder weitere Informationen rund um unser
          Angebot.
        </p>
        <div className="text-base space-y-3 leading-relaxed">
          <p>
            <strong>Oase Salon Massage Kosmetik Fußpflege</strong>
            <br />
            Schäffergasse 1<br />
            1040 Wien, Österreich
          </p>
          <p>
            <strong>Telefon:</strong> +43 660 921 88 78
          </p>
          <p>
            <strong>E-Mail:</strong> oasesalon@gmx.at
          </p>
        </div>
      </div>

      {/* Unten: zwei Spalten – Öffnungszeiten & Karte */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Öffnungszeiten */}
        <div className="bg-gray-900 rounded-2xl shadow-lg p-6">
          <h3 className="text-2xl font-semibold mb-4">Unsere Öffnungszeiten</h3>
          <div className="divide-y divide-gray-700">
            {[
              ["Montag", "Nur mit Termin bitte!"],
              ["Dienstag", "09:00 - 18:00 Uhr"],
              ["Mittwoch", "09:00 - 18:00 Uhr"],
              ["Donnerstag", "09:00 - 18:00 Uhr"],
              ["Freitag", "09:00 - 18:00 Uhr"],
              ["Samstag", "09:00 - 18:00 Uhr"],
              ["Sonntag", "Geschlossen"],
            ].map(([day, time]) => (
              <div key={day} className="flex justify-between py-2 text-lg">
                <span>{day}</span>
                <span>{time}</span>
              </div>
            ))}
          </div>
          <p className="mt-4 text-3sm text-gray-200 italic">
            Hinweis: An Feiertagen haben wir ebenfalls geöffnet!
          </p>
        </div>

        {/* Google Map */}
        <div>
          <iframe
            title="Standort – Oase Salon"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2653.1521786500613!2d16.372426776610764!3d48.19120347124092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476d0792bda41a7d%3A0x4cfc09de2b69e222!2sSch%C3%A4ffergasse%201%2C%201040%20Wien%2C%20%C3%96sterreich!5e0!3m2!1sde!2sat!4v1718718160013!5m2!1sde!2sat"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-xl shadow-lg w-full h-[450px]"
          ></iframe>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;
